export type { EmbeddedPageProps } from './EmbeddedPage';
export { default as EmbeddedPage } from './EmbeddedPage';
